// removed by extract-text-webpack-plugin
module.exports = {"h1":"H1__h1___19ren"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/H1.scss
// module id = 9gj4
// module chunks = 0